import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import { DataGrid } from '../../../common';
import { formatPrice } from '../../../../helpers/format';

import './PaymentReports.scss';

class PaymentsReport extends PureComponent {

    render() {
        const { paymentsReport, canceled } = this.props;

        let columns = [{
            Header: i18next.t('id'),
            accessor: 'orderId',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
        }, {
            Header: i18next.t('restaurant'),
            accessor: 'name',
            filterable: true,
            Cell: row => <a href={`/restaurant/${row.original.restId}`}>{row.value}</a>
        }, {
            Header: i18next.t('amount'),
            accessor: 'amount',
            Cell: row => formatPrice(row.value, row.original.currencyCode, 2),
            filterable: true,
            filterMinMax: { min: 0, max: 1000000 }
        }, {
            id: 'username',
            Header: i18next.t('customer'),
            accessor: row => row.username + ', ' + row.phone,
            Cell: row => <a href={`/loyaltyProgram/1/members/${row.original.userId}`}>{row.value}</a>,
            filterable: true
        }, {
            Header: i18next.t('createDate'),
            accessor: 'createdAt',
            Cell: row => new Date(row.value).toLocaleString(),
            filterable: true,
            filterDate: new Date()
        }];

        if (canceled) {
            columns.push({
                Header: i18next.t('orders.cancelationReason'),
                accessor: 'cancelationReason',
                Cell: row => row.value ? i18next.t(`orders.cancelForm.reasons.${row.value}`) : '',
                filterable: true
            });
            columns.push({
                Header: i18next.t('orders.cancelationDetails'),
                accessor: 'cancelationDetails',
                filterable: true
            });
        }


        return (

            <DataGrid
                data={paymentsReport}
                columns={columns}
                getTrGroupProps={(state, rowInfo, column) => {
                    if (typeof rowInfo !== "undefined") {
                        return {};
                    }
                    return {};
                }}
                // extraActions={this.renderDateSelection()}
                paginated
               
            />
        );
    }
}

PaymentsReport.propTypes = {
    canceled: PropTypes.bool,
    paymentsReport: PropTypes.array,
    
};

const mapStateToProps = (state, ownProps) => {
    const { paymentsReport } = state.businessApp.reports;

    return { paymentsReport };
};

export default withRouter(connect(mapStateToProps, {})(PaymentsReport));
